<template>
<div class="chapter">
<div class="inner_page">
<p class="copy">Publisher: Amy Marson</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Art Director: Kristy Zacharias</p>
<p class="copy">Editor: S. Michele Fry</p>
<p class="copy">Technical Editors: Julie Waldman and Gailen Runge</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinators: Jenny Davis and Freesia Pearson Blizard</p>
<p class="copy">Production Editor: Alice Mace Nakanishi</p>
<p class="copy">Illustrator: Deborah Gale Tirico</p>
<p class="copy">Photo Assistant: Mary Peyton Peppo</p>
<p class="copy">Subject photography by Diane Petersen, style photography by Nissa Brehmer, and instructional photography by Deborah Gale Tirico and Frank Luca Tirico, unless otherwise noted</p>
<p class="copy">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?46b23bfa